import { updateUserData } from "@/services/auth.service";
import {
    Box, CardMedia, TextField, Typography
} from "@mui/material";
import { useState } from "react";
import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import MobileIconImg from '@/assets/images/sources/mobile.png'
import { LoadingButton } from "@/components/common/LoadingButton";

/** 오타 방지용 형식 검사. 번호 소유 여부는 검증하지 않는다(휴대폰 인증 폐지). */
const PHONE_FORMAT = /^01([0|1|6|7|8|9])-?([0-9]{3,4})-?([0-9]{4})$/;

export default function AddPhoneNumber({ setStep }: {
    setStep: React.Dispatch<React.SetStateAction<number>>
}) {
    const { path = '', is_mall_opened = false } = useLoaderData() as {
        path: string; email: string; phone_number: string; is_mall_opened: boolean
    }
    const navigate = useNavigate()
    const { userId = '' } = useParams()
    const [phoneValue, setPhoneValue] = useState('')
    const [loading, setLoading] = useState(false)

    async function handleSubmit() {
        if (!phoneValue.trim()) {
            toast.warning('휴대폰번호를 입력해주세요.', { toastId: 'empty' })
            return;
        }
        if (!PHONE_FORMAT.test(phoneValue)) {
            toast.warning('올바른 휴대폰번호 형식이 아닙니다.', { toastId: 'not passed' })
            return;
        }

        setLoading(true)
        try {
            await updateUserData(userId, { phone_number: phoneValue })
            toast.success('사용자 정보가 업데이트되었습니다.')

            if (!!is_mall_opened) {
                navigate('/')
            } else {
                setStep(1)
            }
        } catch (e: any) {
            toast.error(e?.data?.place_holder || '사용자 정보 업데이트에 실패했습니다. 잠시 후 다시 시도해주세요.')
        } finally {
            setLoading(false)
        }
    }

    return (
        <Box className="flex flex-col" sx={{ gap: 20 }}>
            <Box
                className="flex w-full flex-col justify-center items-center"
                sx={{
                    width: '100%',
                }}
            >
                <Box className="flex justify-center items-center" sx={{ mb: 2 }}>
                    <CardMedia
                        sx={{ width: '30px', mr: .5 }}
                        component={'img'}
                        src={MobileIconImg}
                    />
                    <Typography variant="h6" color={'primary'}>휴대폰번호</Typography>
                    <Typography variant="h6">를 입력해주세요.</Typography>
                </Box>
                <TextField fullWidth
                    value={phoneValue}
                    name="phoneNumber"
                    onChange={(e) => {
                        if (isNaN(Number(e.target.value))) {
                            toast.warning('숫자만 입력해주세요.', { toastId: 'is not number' })
                            return;
                        }
                        setPhoneValue(e.target.value)
                    }}
                    onKeyDown={(event) => {
                        const { altKey, ctrlKey, key } = event;
                        if (altKey || ctrlKey) return;
                        if (key === 'Enter') handleSubmit()
                    }}
                    helperText="휴대폰번호를 적어주세요 ( - 제외)"
                    inputProps={{
                        maxLength: '20', inputMode: 'numeric', pattern: '[0-9]*'
                    }}
                    type="text"
                    InputProps={{
                        style: {
                            backgroundColor: '#ffffff',
                            borderRadius: '6px'
                        },
                    }}
                />
            </Box>
            <LoadingButton fullWidth
                variant="contained" size="large"
                isLoading={loading}
                disabled={!phoneValue.trim()}
                onClick={handleSubmit}
            >
                <b>{!!path ? '시작하기' : '다음'}</b>
            </LoadingButton>
        </Box>
    )
}
